import React, { ReactElement } from 'react'
import { Route, Switch } from 'react-router-dom'
import { Redirect } from 'react-router'
import { Home, Welcome, ConfirmationPage, Maintenance } from '../pages'
import { ROUTES } from '../enums/routes'
import {
  Error401Unauthenticated,
  Error401Unauthorized,
  Error404,
  Error500,
} from '../pages/errors'

function Routes(): ReactElement {
  if (process.env.REACT_APP_IS_MAINTENANCE === 'true') {
    return (
      <Switch>
        <Route path={ROUTES.maintenancePage} exact>
          <Maintenance />
        </Route>
        <Redirect to={ROUTES.maintenancePage} />
      </Switch>
    )
  }

  return (
    <Switch>
      <Route path={ROUTES.home} exact>
        <Home />
      </Route>
      <Route path={ROUTES.unauthenticated} exact>
        <Error401Unauthenticated />
      </Route>
      <Route path={ROUTES.unauthorized} exact>
        <Error401Unauthorized />
      </Route>
      <Route path={ROUTES.pageNotFound} exact>
        <Error404 />
      </Route>
      <Route path={ROUTES.serverError} exact>
        <Error500 />
      </Route>
      <Route path={ROUTES.welcomeWithToken} exact>
        <Welcome />
      </Route>
      <Route path={ROUTES.confirmationPage} exact>
        <ConfirmationPage />
      </Route>
      <Route path={ROUTES.root}>
        <Error404 />
      </Route>
    </Switch>
  )
}

export default Routes
